import { joiningRequestStatuses } from "./constants";

export const getJoiningRequestBulkActions = (activeStatus, labels, handlers) => {
  const byStatus = {
    [joiningRequestStatuses.pending]: [
      {
        key: "approve",
        label: labels.approve,
        tone: "success",
        onClick: handlers?.onApprove,
      },
      {
        key: "reject",
        label: labels.reject,
        tone: "danger",
        onClick: handlers?.onReject,
      },
    ],
    [joiningRequestStatuses.joined]: [
      { key: "unassign", label: labels.unassign, onClick: handlers?.onUnassign },
      { key: "allocate", label: labels.allocate, onClick: handlers?.onAllocate },
      { key: "export", label: labels.export, onClick: handlers?.onExport },
      { key: "editRole", label: labels.editRole, onClick: handlers?.onEditRole },
      { key: "remove", label: labels.remove, tone: "danger", onClick: handlers?.onRemove },
    ],
    [joiningRequestStatuses.rejected]: [
      {
        key: "accept",
        label: labels.accept,
        tone: "success",
        onClick: handlers?.onAccept,
      },
    ],
    [joiningRequestStatuses.removed]: [
      {
        key: "reactivate",
        label: labels.reactivate,
        tone: "success",
        onClick: handlers?.onReactivate,
      },
      {
        key: "editReason",
        label: labels.editReason,
        onClick: handlers?.onEditReason,
      },
    ],
  };

  return byStatus[activeStatus] || [];
};
